import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
const viteEnv = typeof import.meta !== 'undefined' ? import.meta.env : undefined;
const processEnv = typeof process !== 'undefined' ? process.env : {};

const readEnv = (key: string) =>
  viteEnv?.[key as keyof ImportMetaEnv] || processEnv[key] || undefined;

const firebaseConfig = {
  apiKey: readEnv('VITE_FIREBASE_API_KEY') || readEnv('REACT_APP_FIREBASE_API_KEY'),
  authDomain: readEnv('VITE_FIREBASE_AUTH_DOMAIN') || readEnv('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  databaseURL: readEnv('VITE_FIREBASE_DATABASE_URL') || readEnv('REACT_APP_FIREBASE_DATABASE_URL'),
  projectId: readEnv('VITE_FIREBASE_PROJECT_ID') || readEnv('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: readEnv('VITE_FIREBASE_STORAGE_BUCKET') || readEnv('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId:
    readEnv('VITE_FIREBASE_MESSAGING_SENDER_ID') ||
    readEnv('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: readEnv('VITE_FIREBASE_APP_ID') || readEnv('REACT_APP_FIREBASE_APP_ID'),
};

const firestoreDatabaseId = readEnv('VITE_FIRESTORE_DATABASE_ID') || '(default)';

// Only initialize Firebase if config is present (allows SSR/SSG on Vercel without env vars)
let app: any = null;
let auth: any = null;
let db: any = null;
let storage: any = null;

const isConfigValid =
  firebaseConfig.apiKey &&
  firebaseConfig.projectId &&
  firebaseConfig.appId &&
  firebaseConfig.authDomain &&
  firebaseConfig.storageBucket &&
  firebaseConfig.messagingSenderId;

if (isConfigValid) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app, firestoreDatabaseId);
  storage = getStorage(app);
  // TODO: remove before production
  console.log('Firebase config loaded:', firebaseConfig.projectId);
} else {
  console.warn('Firebase config missing. Firebase features will be disabled.');
}

export { auth, db, storage };
export default app;
